<template>
    <div class="relative text-base group sm:text-sm">
        <div class="p-1 overflow-hidden group-hover:opacity-75">
        <a v-if="post.featuredImageUrl"
               :href="`/blog/${post.slug}`"
               :alt="post.title"
               :title="post.title" class=" guide-img-container aspect-3/2">
           
            <img class="object-cover w-full rounded-lg shadow-lg aspect-3/2"
                         :src="post.featuredImageUrl"
                         :alt="post.title"
                         :title="post.title">
           
        </a>

        </div>
        <p class="p-1 text-xs">{{ post.publishedOnAsString }}</p>
        <a :href="`/blog/${post.slug}`"
            :alt="post.title"
            :title="post.title"
            class="block p-1 font-medium text-gray-900">
            <h3 class="">{{ post.title.slice(0, 90) }}</h3>
        </a>
        
    </div>
    
</template>

<script lang="ts" setup>
import {defineProps} from "vue";
import {BlogPostDtoLightweight} from "@/dtos";

const props = defineProps<{
    post: BlogPostDtoLightweight,
}>();

const post: BlogPostDtoLightweight = props.post;

</script>
<style>

</style>